import React from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles, Avatar, Typography, Box } from '@material-ui/core';
import { AvatarWithoutPhoto } from '../Shared/AvatarWithoutPhoto';
import { useTranslation } from 'react-i18next';
import { EmptyState } from '../Shared';
import iconEmptyStateUps from '../../assets/imgs/emptystate/illustration_empty-state-ups.svg';

const useStyle = makeStyles((theme) => ({
  root: {
    width: 500,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    padding: theme.spacing(3, 0),
  },
  grow: {
    flexGrow: 1,
    paddingLeft: theme.spacing(1.5)
  },
  container: {
    paddingBottom: theme.spacing(2.3),
    display: 'flex',
  },
  photo: {
    width: 45,
    height: 45,
    marginRight: 15,
  },
  avatar: {
    width: 45,
    height: 45,
  },
  userName: {
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    }
  },
  position: {
    color: theme.palette.neutrals.low.light,
    fontSize: 12.2,
    fontWeight: 500,
  }
}));

function IdeaUpContent({ ups }) {
  const classes = useStyle();
  const { t } = useTranslation();
  const history = useHistory();

  function handleDirectToUserProfile(id) {
    history.push(`/profile/${id}`);
  }

  return (
    <div className={classes.root}>
      {ups <= 0 ? (
        <EmptyState
          icon={iconEmptyStateUps}
          description={<>
            {t('ainda_nao_ha_ups')} <br />
            {t('na_publicacao')}
          </>}
        />
      ) : (
        <div className={classes.grow}>
          {ups &&
            ups.map((ups, index) => (
              <div key={index}>
                <div className={classes.container}>
                  <span className={classes.photo}>
                    {ups.attachment?.url ? (
                      <Avatar 
                        className={classes.avatar} 
                        src={ups.attachment.url} 
                      />
                    ) : (
                      <AvatarWithoutPhoto medium userName={ups.name} />
                    )}
                  </span>
                  <Box display="flex" flexDirection="column" justifyContent="center">
                    <Typography
                      variant="subtitle2"
                      className={classes.userName}
                      onClick={() => handleDirectToUserProfile(ups._id)}
                    >
                      {ups.name}
                    </Typography>
                    <span className={classes.position}>
                      {ups.position}
                    </span>
                  </Box>
                </div>
              </div>
            ))
          }
        </div>
        )}
    </div>
  );
}

export { IdeaUpContent };
